import { ExcelImportApi } from "../Api";
import { getAuthConfiguration } from "./configuration";

const ApiFactory = () => new ExcelImportApi(getAuthConfiguration());

export const importFromExcel = (programId: string, file: Blob) => {
    return ApiFactory().apiExcelImportImportExcelUIPost({ programId, file });
}